import dateAfterToday from './dateAfterToday'
import dateByFormat from './dateByFormat'
import dateMinRange from './dateMinRange'
import { default as email, emailDisplayName, emailLocalPart } from './email'
import emailFromSpec from './emailFromSpec'
import multiDomain from './multiDomain'
import validateNumber from './number'
import { confirmPassword } from './passwordValidation'
import required, { DEFAULT_REQUIRED_MESSAGE } from './required'
import { stringMaxLength, stringMinLength } from './stringLength'
import timeInFuture from './timeInFuture'
import wizardDate from './wizardDate'
import workingHours from './workingHours'

const positiveNumber = validateNumber({ min: 1 })

const notEmptyArray = (arr) => (arr?.length ? undefined : DEFAULT_REQUIRED_MESSAGE)

const validateForm = (form, validations, parentClassName) => {
  const mapDOMFields = {}
  document.querySelectorAll(`.${parentClassName} input`).forEach((elem) => {
    elem.classList.remove('error')
    mapDOMFields[elem.name] = elem
  })

  const notValidNames = Object.keys(form)
    .filter((fieldName) => !validations[fieldName]() && !mapDOMFields[fieldName].disabled)
    .map((fieldName) => mapDOMFields[fieldName].classList.add('error'))

  return !notValidNames.length
}

const validateAll = (arr) => arr.filter((res) => res)[0]

export {
  validateAll,
  required,
  dateByFormat,
  dateMinRange,
  workingHours,
  timeInFuture,
  positiveNumber,
  confirmPassword,
  notEmptyArray,
  dateAfterToday,
  validateForm,
  wizardDate,
  email,
  emailLocalPart,
  emailDisplayName,
  emailFromSpec,
  stringMinLength,
  stringMaxLength,
  multiDomain,
}
